import Highway from '@dogstudio/highway'
import modular from 'modujs'
import { classesInjection } from './utils/transitions'
import { Fade } from './modules/Transitions'
import Scroller from './modules/Scroller'

import * as modules from './modules'

const app = new modular({
  modules,
})

class DefaultRenderer extends Highway.Renderer {
  onEnterCompleted() {
    app.init(app)
  }
}

const init = () => {
  classesInjection()
  new Scroller()

  const H = new Highway.Core({
    renderers: {
      default: DefaultRenderer,
    },
    transitions: {
      default: Fade,
    },
  })

  H.on('NAVIGATE_IN', () => {
    document.dispatchEvent(new Event('page:change'))
    console.log('NAVIGATE_IN')
  })

  window.H = H
}

document.addEventListener('DOMContentLoaded', init)
